import { render, staticRenderFns } from "./booking-view-list.vue?vue&type=template&id=13f24e84&"
import script from "./booking-view-list.vue?vue&type=script&lang=js&"
export * from "./booking-view-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports